import {
  CREATE_PROJECT,
  GET_PROJECT,
  GET_PROJECTS,
  NAVIGATION,
} from '../types';
import { error, success } from '../utils';

export let initialState = {
  createProject: {
    isLoading: false,
    isError: false,
  },
  getProject: {
    isLoading: false,
    isError: false,
  },
  getProjects: {
    isLoading: false,
    isError: false,
  },
  project: null,
  projects: [],
};

const reducer = (state, action) => {
  state = state || initialState;

  switch (action.type) {
    case GET_PROJECT:
      return {
        ...state,
        getProject: {
          isLoading: true,
          isError: false,
        },
      };
    case success(GET_PROJECT):
      return {
        ...state,
        getProject: {
          isLoading: false,
          isError: false,
        },
        project: action.payload.data,
      };
    case error(GET_PROJECT):
      return {
        ...state,
        getProject: {
          isLoading: false,
          isError: true,
        },
      };

    case GET_PROJECTS:
      return {
        ...state,
        getProjects: {
          isLoading: true,
          isError: false,
        },
      };
    case success(GET_PROJECTS):
      return {
        ...state,
        getProjects: {
          isLoading: false,
          isError: false,
        },
        projects: action.payload.data,
      };
    case error(GET_PROJECTS):
      return {
        ...state,
        getProjects: {
          isLoading: false,
          isError: true,
        },
      };

    case CREATE_PROJECT:
      return {
        ...state,
        createProject: {
          isLoading: true,
          isError: false,
        },
      };
    case success(CREATE_PROJECT):
      return {
        ...state,
        createProject: {
          isLoading: false,
          isError: false,
        },
      };
    case error(CREATE_PROJECT):
      return {
        ...state,
        createProject: {
          isLoading: false,
          isError: true,
        },
      };

    case NAVIGATION:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
